<template>

  <form v-on:submit="save" action="#" method="post" id="" v-if="user">

    <div class="row">

      <div class="col-xs-4">
        <div class="form-group ">
          <label class="required">Gender
            <span v-if="errorGender" class="error">{{ errorGender }}</span>
          </label>

          <v-select2 label="name" :options="genders" v-model="user.gender"
                     :class="{'has-error' : errorGender, 'has-success' : errorGender === false}"></v-select2>
        </div>
      </div>
      <div class="col-xs-4">
        <div class="form-group ">
          <label for="firstname" class="required">First Name
            <span v-if="errorFirstName" class="error">{{ errorFirstName }}</span>
          </label>
          <input v-model="user.firstname" id="firstname" class="form-control" placeholder="name" required
                 max="100" :class="{'has-error' : errorFirstName, 'has-success' : errorFirstName === false}">
        </div>
      </div>
      <div class="col-xs-4">
        <div class="form-group">
          <label for="lastname" class="required">Last Name
            <span v-if="errorLastName" class="error">{{ errorLastName }}</span>
          </label>
          <input v-model="user.lastname" id="lastname" class="form-control" placeholder="Last name" required
                 max="100" :class="{'has-error' : errorLastName, 'has-success' : errorLastName === false}">
        </div>
      </div>

    </div>

    <div class="row">

      <div class="col-xs-4">
        <div class="form-group " >
          <label for="email" class="required">Email
            <span v-if="errorEmail" class="error">{{ errorEmail }}</span>
          </label>
          <input v-model="user.email" id="email" class="form-control" placeholder="Email" required
                 max="100" :class="{'has-error' : errorEmail, 'has-success' : errorEmail === false}">
        </div>
      </div>
      <div class="col-xs-4 col-xs-offset-4">
        <div class="form-group " >
          <label for="phone" class="">Phone
            <span v-if="errorPhone" class="error">{{ errorPhone }}</span>
          </label>
          <input v-model="user.phone" id="phone" class="form-control" placeholder="Phone number"
                 max="100" :class="{'has-error' : errorPhone, 'has-success' : errorPhone === false}">
        </div>
      </div>
    </div>
    <div class="row" style="margin-top: 15px">
      <div class="col-xs-12">
        <div class="form-group ">
          <div class="checkbox checkbox-info checkbox-inline">
            <input id="is_email_optin" type="checkbox" name="" v-model="user.is_optin">
            <label for="is_email_optin" class=""> I agree to receive emails from Idexlab.</label>
          </div>
          <span class="help-block m-b-none" style="margin-bottom: 10px">Idexlab is committed to protecting and respecting your privacy. We will only use your personal data to manage your account and provide you with the requested products and services. We would like to contact you occasionally about our products and services, as well as other content that may be of interest to you. If you agree to us contacting you for this purpose, please indicate your preferred means of communication by ticking the corresponding box below.</span>
        </div>
      </div>
    </div>
    <div class="row" style="margin-top: 15px">
      <div class="col-xs-12">
        <vue-ladda type="submit" :loading="submit.loading" class="btn btn-info pull-right" :data-style="submit.dataStyle"> Save Changes
        </vue-ladda>
      </div>
    </div>
  </form>
</template>

<style scoped>

</style>
<script>

import vSelect2 from '../../components/utils/select2'
import VueLadda from 'vue-ladda'

export default {
  components: {VueLadda, vSelect2},
  name: 'PersonalInformation',
  props: ['user'],
  data () {
    return {
      errorGender: null,
      errorFirstName: null,
      errorLastName: null,
      errorPhone: null,
      errorEmail: null,
      genders: [],
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      }
    }
  },
  methods: {
    save: function (e) {
      e.preventDefault()

      this.submit.loading = true

      this.errorGender = null
      this.errorFirstName = null
      this.errorLastName = null
      this.errorPhone = null
      this.errorEmail = null

      this.axios.patch('user/' + this.user.id + '/personalInformation', {
        first_name: this.user.firstname,
        last_name: this.user.lastname,
        email: this.user.email,
        gender_id: this.user.gender !== null ? this.user.gender.id : null,
        phone: this.user.phone,
        is_optin: this.user.is_optin
      }).then((response) => {
        this.$notify({
          type: 'success',
          title: 'Updated !',
          placement: 'bottom-right'
        })

        this.$salesMachine.editUser(response.data)
      }).catch((error) => {
        let errors = error.response.data.errors

        if (typeof errors['first_name'] !== 'undefined') {
          this.errorFirstName = errors['first_name'][0]
        } if (typeof errors['last_name'] !== 'undefined') {
          this.errorLastName = errors['last_name'][0]
        } if (typeof errors['gender_id'] !== 'undefined') {
          this.errorGender = errors['gender_id'][0]
        } if (typeof errors['email'] !== 'undefined') {
          this.errorEmail = errors['email'][0]
        } if (typeof errors['phone'] !== 'undefined') {
          this.errorPhone = errors['phone'][0]
        }
      }).finally(() => {
        this.submit.loading = false
      })
    },
    getResources: function () {
      this.axios.get('/genders')
        .then((response) => {
          this.genders = response.data.map((gender) => {
            gender.text = gender.name
            return gender
          })
        })
        .catch(function (error) {
        })
    }
  },
  beforeMount () {
    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/PersonalInformation.vue